import { Ban, Home, WifiOff } from "lucide-react";
import { Link, isRouteErrorResponse, useRouteError } from "react-router-dom";

export function ForbiddenPage() {
  return (
    <main className="center-screen">
      <div className="error-page">
        <Ban aria-hidden="true" />
        <h1>لا تملك صلاحية الوصول</h1>
        <p>هذه الصفحة خارج الدور أو النطاق الممنوح لك.</p>
        <Link className="button" to="/dashboard">
          <Home aria-hidden="true" />
          العودة للرئيسية
        </Link>
      </div>
    </main>
  );
}
export function RouteErrorPage() {
  const error = useRouteError();
  const message =
    isRouteErrorResponse(error) && error.status === 404
      ? "الصفحة المطلوبة غير موجودة."
      : "تعذر فتح الصفحة الآن.";
  return (
    <main className="center-screen">
      <div className="error-page">
        <WifiOff aria-hidden="true" />
        <h1>{message}</h1>
        <p>عد إلى الصفحة الرئيسية أو حاول مرة أخرى.</p>
        <Link className="button" to="/">
          <Home aria-hidden="true" />
          الصفحة الرئيسية
        </Link>
      </div>
    </main>
  );
}
